import { Box, Checkbox, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { getImageSrc } from '../../helpers/getImageSrc'

type FormCheckboxProps<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
  label?: string
  withFireIcon?: boolean
  disabled?: boolean
}

const FormCheckbox = <T extends FieldValues>(props: FormCheckboxProps<T>) => {
  const { control, name, label, withFireIcon, disabled } = props

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...field } }) => (
        <Box
          className={'fx-nowrap aln-center'}
          sx={{
            cursor: 'default',
            height: '100%',
          }}
        >
          <Checkbox
            sx={{ padding: '0 8px 0 0' }}
            checked={value}
            onChange={
              disabled ? undefined : (e) => field.onChange(e.target.checked)
            }
          />
          {withFireIcon && (
            <img
              src={getImageSrc('fire')}
              style={{ width: '18px', marginRight: '4px' }}
            />
          )}
          <Typography
            variant={'body1'}
            sx={{
              whiteSpace: 'nowrap',
              fontWeight: '400',
            }}
          >
            {label}
          </Typography>
        </Box>
      )}
    />
  )
}

export default observer(FormCheckbox)
